<mat-tab-group (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="returnTabIndex">
  <mat-tab  *ngFor="let item of config" [label]="item.name">
    <div class="u-margin-top-20">
      <app-tile *ngFor="let feature of item.itemList" class="u-display-inline-block u-margin-right-20 u-margin-bottom-20" [category]="item.name" [isFeatureStorePage]="isFeatureStorePage" [tabIndexToReturn]="item.tabIndexToReturn" [config]="feature"></app-tile>
    </div>
  </mat-tab>
</mat-tab-group>
